import { InventoryGetModel } from '@/shared/types/inventory.type';
import Response from '@/shared/types/response';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

const viewInventory = async <B = unknown>(
  body: B,
  onUnauthorized?: () => void,
) => {
  const token = getCookie('auth_token');

  try {
    const response = await fetcher<
      Response<{
        [key: string]: InventoryGetModel;
      }>
    >({
      url: '/inventory/view/',
      method: 'POST',
      body,
      token,
      timeout: 60 * 1000 * 5, // 5 minutes
      onUnauthorized,
    });

    const inventory: InventoryGetModel[] = Object.entries(response.data).map(
      ([key, value]) => ({
        ...value,
        inventory_id: key,
      }),
    );

    return {
      ...response,
      data: inventory,
    };
  } catch (error) {
    console.error(
      'Error occurred in function "viewInventory" in file "src/shared/api/inventory/viewInventory.ts":',
      error,
    );
    return error as Response<InventoryGetModel[]>;
  }
};

export default viewInventory;
